import { render, staticRenderFns } from "./Rates.vue?vue&type=template&id=74e6ce7e"
import script from "./Rates.vue?vue&type=script&lang=js"
export * from "./Rates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e6ce7e')) {
      api.createRecord('74e6ce7e', component.options)
    } else {
      api.reload('74e6ce7e', component.options)
    }
    module.hot.accept("./Rates.vue?vue&type=template&id=74e6ce7e", function () {
      api.rerender('74e6ce7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/Rates.vue"
export default component.exports